import styled from 'styled-components';

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  margin-top: 2rem;
  align-items: center;

  > div {
    width: 100%;
    flex: 1;
  }

  > button {
    margin-top: 2rem;
  }
`;
